import React, { FC } from 'react';
import './ChangePassword.css';

interface ChangePasswordProps {}

const ChangePassword: FC<ChangePasswordProps> = () => (
  <div className="ChangePassword">
    ChangePassword Component
  </div>
);

export default ChangePassword;
